var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center p-5"},[_c('h4',[_vm._v("Thank You")]),_c('p',[_vm._v("A verification Email has been sent to your address")]),_c('b-button',{attrs:{"variant":"secondary"},on:{"click":_vm.handleOK}},[_vm._v("Ok")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }